"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("antd/lib/button"));
var _classnames = _interopRequireDefault(require("classnames"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var InternalButton = function InternalButton(_a) {
  var _a$autoLoading = _a.autoLoading,
    autoLoading = _a$autoLoading === void 0 ? false : _a$autoLoading,
    propLoading = _a.loading,
    _a$active = _a.active,
    propActive = _a$active === void 0 ? false : _a$active,
    onActiveChange = _a.onActiveChange,
    propClick = _a.onClick,
    className = _a.className,
    size = _a.size,
    type = _a.type,
    restProps = __rest(_a, ["autoLoading", "loading", "active", "onActiveChange", "onClick", "className", "size", "type"]);
  var _useState = (0, _react.useState)(propLoading),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(propActive),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!autoLoading) {
      // 如果设置了autoLoading，理论上 loading就被内部接管了，props就不该传loading过来，传了也无视
      setLoading(propLoading);
    }
  }, [propLoading]);
  (0, _react.useEffect)(function () {
    if (type === 'highlight') {
      setActive(propActive);
    }
  }, [propActive]);
  var onClick = function onClick(e) {
    var onClickEvent = propClick;
    if (type === 'highlight') {
      setActive(!active);
      if (typeof onActiveChange === 'function') {
        onActiveChange(!active);
      }
    }
    if (autoLoading && propClick) {
      // 如果没有点击事件， 不用设置loading
      onClickEvent = function onClickEvent() {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return propClick(e);
              case 4:
                _context.prev = 4;
                setLoading(false);
                return _context.finish(4);
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1,, 4, 7]]);
        }));
      };
    }
    return onClickEvent === null || onClickEvent === void 0 ? void 0 : onClickEvent(e);
  };
  return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
    loading: loading,
    onClick: onClick,
    size: size,
    type: type,
    className: (0, _classnames["default"])(className, {
      'dpl-button-highlight-active': active
    }, {
      'ant-btn-xs': size === 'extraSmall'
    })
  }, restProps));
};
var Button = InternalButton;
(0, _hoistNonReactStatics["default"])(Button, _button["default"]);
var _default = exports["default"] = Button;